import React, { Component } from 'react';
import WheelComponent from "./WheelComponent";
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import jwt_decode from "jwt-decode";
import './luckywheel.css';

// สีสำรองสำหรับช่องรางวัล (ถ้า backend ไม่ได้กำหนดสี)
const PALETTE = ['#C0392B', '#E67E22', '#F1C40F', '#27AE60', '#2980B9', '#8E44AD', '#16A085', '#D35400', '#2C3E50', '#1ABC9C'];
// ชุดตัวอย่าง (ใช้เฉพาะตอน backend ยังไม่ได้ตั้งรางวัล) เพื่อให้เห็นว่ากงล้อทำงาน
const DEMO = [
    { id: 1, name: '5 บาท' }, { id: 2, name: '10 บาท' }, { id: 3, name: '20 บาท' }, { id: 4, name: '50 บาท' },
    { id: 5, name: '100 บาท' }, { id: 6, name: 'ลุ้นใหม่' }, { id: 7, name: '300 บาท' }, { id: 8, name: '500 บาท' },
];

class LuckyWheelPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            point: 0,
            user_id: "",
            disable: false,
            segColors: null,
            segments: null,
            lock: "",
            amount: 0,
            loaded: false,
            isDemo: false,
        };
    }

    componentDidMount() {
        this.checklogin();
        this.getwheel();
    }

    checklogin() {
        const token = localStorage.getItem('auth_token');
        if (token != null) {
            try {
                const decoded = jwt_decode(token);
                this.setState({ user_id: decoded.message.playerid, point: decoded.message.Point, disable: true });
            } catch (e) { }
        }
    }

    getwheel = async () => {
        try {
            const res = await instance.post("/api/v1/getwheelspin", { System: Systems });
            const datas = (res.data && res.data.status === 200 && Array.isArray(res.data.message)) ? res.data.message : [];
            const amount = res.data && res.data.tblwheelsetting && res.data.tblwheelsetting[0] ? res.data.tblwheelsetting[0].amount : 0;
            if (datas.length > 0) {
                const segments = datas.map((d) => ({ id: d.id, name: d.description }));
                const segColors = datas.map((d, i) => d.color || PALETTE[i % PALETTE.length]);
                this.setState({ segments, segColors, amount, loaded: true, isDemo: false, lock: segments[0].name });
            } else {
                // ยังไม่มีรางวัลจริง → โชว์ชุดตัวอย่าง พร้อมแจ้งเตือน
                const segments = DEMO;
                const segColors = DEMO.map((d, i) => PALETTE[i % PALETTE.length]);
                this.setState({ segments, segColors, amount, loaded: true, isDemo: true, lock: segments[0].name });
            }
        } catch (e) {
            const segments = DEMO;
            const segColors = DEMO.map((d, i) => PALETTE[i % PALETTE.length]);
            this.setState({ segments, segColors, loaded: true, isDemo: true, lock: segments[0].name });
        }
    }

    onFinished = async (winner) => {
        if (this.state.isDemo) return; // โหมดตัวอย่าง ไม่บันทึก
        const token = localStorage.getItem('auth_token');
        if (token == null) return;
        try {
            const decoded = jwt_decode(token);
            const Username = decoded.message.playerid;
            await instance.post("/api/v1/postwheelspin", {
                System: Systems, userid: Username, type: 1, rows: { wheelID: winner.id, userid: Username },
            });
        } catch (e) { }
    }

    back = (e) => { if (this.props.onNavigate) this.props.onNavigate('/home', e); }

    render() {
        const { segments, segColors, loaded, point, amount, isDemo } = this.state;
        const hasPrizes = segments && segments.length > 0;
        return (
            <div className="luckywheel-scope">
                <div className="lw-header">
                    <span role="button" onClick={this.back} className="lw-back">&#8249;</span>
                    <span className="lw-title">กงล้อพารวย</span>
                    <span style={{ width: 16 }} />
                </div>

                <div className="lw-ticket">
                    <span>ตั๋วหมุนกงล้อ</span>
                    <span>{point || 0} สิทธิ์</span>
                </div>

                {isDemo && (
                    <div className="lw-demo-note">โหมดตัวอย่าง — ยังไม่ได้ตั้งรางวัลกงล้อในระบบหลังบ้าน (System: ufag168)</div>
                )}

                {!loaded ? (
                    <div className="lw-empty">กำลังโหลด...</div>
                ) : hasPrizes ? (
                    <div className="lw-wheel-wrap">
                        <WheelComponent
                            segments={segments}
                            segColors={segColors}
                            winningSegment={this.state.lock}
                            userid={this.state.user_id}
                            disablex={this.state.disable}
                            onFinished={(w) => this.onFinished(w)}
                            primaryColor="#1a1a1a"
                            contrastColor="#ffffff"
                            round={point}
                            buttonText="หมุน"
                            upDuration={500}
                            downDuration={600}
                            fontFamily="Kanit, Helvetica, Arial, sans-serif"
                        />
                    </div>
                ) : (
                    <div className="lw-empty">
                        <div className="lw-empty-emoji">🎡</div>
                        ยังไม่มีรางวัลในกงล้อ<br />กรุณาเพิ่มรางวัลกงล้อในระบบหลังบ้าน
                    </div>
                )}

                <div className="lw-info">
                    <div>ฝากเงินสะสม {amount || 0} บาท ได้ 1 สิทธิ์</div>
                    <div className="lw-cond">เงื่อนไข: หมุนได้เมื่อมีสิทธิ์ • รางวัลที่ได้จะถูกเพิ่มเข้าเครดิตอัตโนมัติ • สงวนสิทธิ์ตามที่เว็บกำหนด</div>
                </div>
            </div>
        );
    }
}

export default LuckyWheelPage;
